import {Injectable} from "@angular/core"
import {ApiService, GenericResponse, GenericResponsePage} from "@uranda/commons"
import {ReportRequest, Support, SupportFilter, UpdateLeadOriginRequest} from "../app/models/support.model"
import {HttpParams} from "@angular/common/http";
import {ColumnSorting} from "@uranda/ui";
import {DashboardCounters} from "../app/models/dashboardCounters.model";
import {LeadSource} from "../app/models/lead.model";

@Injectable({
  providedIn: 'root'
})
export class SupportService extends ApiService {

  async getSupportLeads(
    page: number = 0,
    size: number = 25,
    filters?: SupportFilter,
    q: string = '',
    currentSort?: ColumnSorting[],
    leadSource?: LeadSource
  ): Promise<GenericResponsePage<Support[]>> {
    let queryParameters = new HttpParams()
      .set('page', page)
      .set('size', size)
      .set('q', q);

    if (filters) {
      queryParameters = queryParameters.append('status', filters.status || "OLD");
    }
    if (filters) {
      queryParameters = queryParameters.append('verificationStatus', filters.verificationStatus || "VERIFIED");
    }
    if (leadSource) {
      queryParameters = queryParameters.set('leadSource', leadSource);
    }
    if (currentSort && currentSort.length !== 0) {
      queryParameters = queryParameters.append('orderBy', currentSort[0].attributeName ?? '');
      queryParameters = queryParameters.append('direction', currentSort[0].direction ?? '');
    }
    const response = await this.get("/v1/support", queryParameters);
    return response.data;
  }

  async getSupportById(leadId: number): Promise<GenericResponse<Support>> {
    return await this.get(`/v1/support/${leadId}`)
  }

  async resend(leadId: string){
    return await this.post(`/v1/support/${leadId}/resend-email`)
  }

  async resendSms(leadId: string){
    return await this.post(`/v1/support/${leadId}/resend-sms`)
  }

  /** Solo ruolo SUPPORT: corregge prefisso telefonico e/o nazione di provenienza del paziente. */
  async updateContactOrigin(leadId: string, request: UpdateLeadOriginRequest): Promise<Support> {
    const response = await this.put(`/v1/support/${leadId}/contact-origin`, request);
    return response.data;
  }

  async report(leadId: string, reportRequest: ReportRequest){
    return await this.post(`/v1/support/${leadId}/report`, reportRequest)
  }

  async getCounters(): Promise<DashboardCounters> {
    return (await this.get('/v1/support/dashboard/counters')).data;
  }

}
